
import React from 'react'
import { Link as GatsbyLink } from 'gatsby'

const EXTERNAL_ROUTE_REDIRECTS = {
  '/products': 'https://eastoncraft.dispensary.shop/rec/menu',
  '/deals': 'https://eastoncraft.dispensary.shop/rec/menu',
}

const normalizePathname = (path) => {
  if (!path || path === '/') {
    return '/'
  }

  return path.endsWith('/') ? path.slice(0, -1) : path
}

const getExternalRedirectTarget = (to) => {
  if (typeof to !== 'string' || !to.startsWith('/')) {
    return null
  }

  const pathname = to.split('?')[0]
  const normalizedPathname = normalizePathname(pathname)

  return EXTERNAL_ROUTE_REDIRECTS[normalizedPathname] || null
}

export const Link = ({ children, to,  className, ...rest }) => {
  const externalRedirectTarget = getExternalRedirectTarget(to)

  if (externalRedirectTarget) {
    return (
      <a href={externalRedirectTarget} className={className} {...rest}>
        {children}
      </a>
    )
  }

  // regex test - internal link starts with slash(/) but not in-page link(#)
  const internal = /^\/(?!\/)/.test(to)

  if (internal) {
    return (
      <GatsbyLink
        to={to}
        className={className}
        activeClassName="active"
        {...rest}
      >
        {children}
      </GatsbyLink>
    )
  }

  return (
    <a href={to} className={className} {...rest}>
      {children}
    </a>
  )
}
